import React, {
  useEffect,
  useState,
} from 'react';

import { useNavigate } from 'react-router-dom';
import {
  useRecoilState,
  useRecoilValue,
} from 'recoil';
import {
  isAdmin,
  subMenuState,
} from 'state';
import styled from 'styled-components';
import Products from 'view/pages/Coaching/SubPage/Products';
import Requested from 'view/pages/Coaching/SubPage/Requested';

import PlutIcon from '../../../assets/images/plus.png';
import {
  Banner,
  ContentBox,
  Contents,
  Icon,
} from '../../components';
import Completed from "./SubPage/Completed";
import InProgress from "./SubPage/InProgress";
import Published from "./SubPage/Published";
import {isEmpty} from "../../../util";

interface StyledComponentProps {
    width?: string;
    display?: string;
}

const Coaching = () => {
    const navigate = useNavigate();
    const isAdminState = useRecoilValue(isAdmin);
    const [subMenu, setSubMenu] = useRecoilState(subMenuState);
    const [popup, setOnpopup] = useState(false);
    const getSubPage = (subMenu) => {
        switch (subMenu) {
            case "Products":{
                return <Products popup={popup} />
            }                
            case "Requested":{
                return <Requested/>
            }
            case "Completed":{
              return  <Completed/>
            }
            case "In Progress":{
                return  <InProgress/>
            }
            case "Published":{
                return <Published></Published>
            }
        }
    };
    useEffect(() => {
        document.addEventListener("keydown",(e)=>{
            if(e.keyCode === 27){
                setOnpopup(false)
            }
        })
        document.addEventListener("click",()=>{
            setOnpopup(false)
        })
    }, []);
    useEffect(() => {
        if (isAdminState) {
            if(isEmpty(subMenu)){
                setSubMenu("In Progress");
            }

        } else {
            if(isEmpty(subMenu)){
                setSubMenu("Products");
            }
        }
    }, [isAdminState]);

    return (
        <Container>
            <ContentsWrap>
                <Wrap>
                    <ContentBox>     {
                        subMenu == "Products" &&
                        <Banner img={"/images/banner-publish.png"}
                                url={"/images/banner-publish.png"}
                                width={"100%"} height={220}>
                                <BannerContents>
                                    <div className="textarea">
                                        <h2>Want to publish more classes?</h2>
                                        <p>
                                            Lorem ipsum dolor sit amet consectetur. Pellentesque porttitor in pellentesque
                                            pellentesque nec consequat mon.
                                        </p>
                                    </div>
                                    {!isAdminState && subMenu === "Products" && (
                                        <Create
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setOnpopup(v => !v)
                                            }}
                                        >
                                            <CreateContents>
                                                <Icon icon={PlutIcon}/>
                                                <span>Create Coaching</span>
                                            </CreateContents>
                                        </Create>
                                    )}
                                </BannerContents>
                        </Banner>
                        }
                        <Contents title={subMenu}>
                            {
                                getSubPage(subMenu)
                            }                                        
                        </Contents>
                    </ContentBox>
                </Wrap>
            </ContentsWrap>
        </Container>
    );
};
export default Coaching;

const Container = styled.div``;
const ContentsWrap = styled.div`
    display: flex;
    width: 100%;
`;
const Wrap = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    flex: 1;
    .banner{
        height: 220px;
    }
`;

const BannerContents = styled.div`
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
    padding: 25px 20px;
    height: 220px;
    background: linear-gradient(269.04deg, rgba(0, 0, 0, 0) 39%, rgba(0, 0, 0, 0.75) 79.51%);
    h2 {
        text-transform: uppercase;
        color: #fff;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 10px;
        opacity: 0.9;
        line-height: 35.28px;
        width: 100%;
        font-family: "Source Serif 4", sans-serif;;
        @media screen and (max-width: 768px) {
            line-height: 1.2em;
            font-size: 1.2em;
        }
    }
    p {
        opacity: 0.8;
        color: #fff;
        width: 470px;
        line-height: 24px;
        font-size: 18px;
        margin-bottom: 30px;
        font-weight: 400;
        @media screen and (max-width: 406px) {
            line-height: 1.1em;
            font-size: 1em;
        }
        @media screen and (max-width: 768px) {
            //font-size: 2.5vw;
            //font-size: 50%;

            margin-bottom: 10px;
            width: 100%;
        }
    }
`;
const Create = styled.div`
    background: #ddc160;
    font-size: 16px;
    width: 170px;
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    padding: 10px 0px;
    cursor: pointer;
    transition: all 0.2s;
    &:hover{
        transform: scale(1.05);
    }
    img {
        width: 16px;
        height: 16px;
    }
`;
const CreateContents = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;

    span {
        line-height: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        margin-left: 6px;
    }
`;
